export default "__VITE_ASSET__b27f0c47__"